import {nextTick} from "vue";

export function triggerUpgrade(store, type) {
    store.commit('showNeedUpgrade', type);

    nextTick(() => {
        store.commit('showNeedUpgrade', false)
    });
}

export function triggerUpsell(store) {
    store.state.showUpsell = true;

    nextTick(() => {
        store.state.showUpsell = false;
    });
}
